
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component<SelectInput>({
    model: {
        prop: 'value',
        event: 'change',
    },
})
export default class SelectInput extends Vue {
    @Prop(String) public value!: string
    @Prop(String) public label!: string
    @Prop(Array) public options!: string[]
    @Prop(Array) public optionLabels!: string[]
}
